// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'

class Account extends Model {
    defaults() {
        return {
            id:   null,
            name: "",
            description:"",
            website: '',
            accreditation: '',
            year_founded: '',
            facebook_link: '',
            twitter_link: '',
            youtube_link: '',
            instagram_link: '',
            phone: '',
            show_map: false,
            tag_line: '',
            translations: {es:{}},
            preview: false,
            links: [],
            contacts: [],
            addresses: [],
            photos: [],
            organizations:[],
            org_list: [],
        }
    }
    mutations() {
        return {
            id:   (id) => Number(id) || null,
            preview: Boolean,
        }
    }
}

export {
    Account
}